export const MaxLogsForDiagnosticsPanel = 500;
